import React from 'react'
import ListGroupBatchPage from './ListGroupBatchPage'

const ListGroupBatchContainer = () => {
    return (
        <div className='ListGroupBatchContainer'>
            <ListGroupBatchPage />
        </div>
    )
}

export default ListGroupBatchContainer